import { useState } from 'react';
import { useDocumentHistoryByIdQuery } from '../../../../services/historyApi';

const tabs: { [key: string]: string } = {
    0: 'movimientos',
    1: 'descargas'
};
function useDocumentHistory({ docId }: any) {
    const [tabValue, setTabValue] = useState(0);
    const {
        data,
        isLoading: isLoadingData,
        isFetching: isFetchingData
    } = useDocumentHistoryByIdQuery(
        { docId: docId, tab: tabs[tabValue] },
        {
            skip: !docId,
            refetchOnMountOrArgChange: false
        }
    );

    const handleChangeTabValue = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    return {
        tabValue,
        data,
        isLoadingData,
        isFetchingData,
        handleChangeTabValue
    };
}

export default useDocumentHistory;
